// extracted by mini-css-extract-plugin
export default {"button":"Languages_button__VXTDx","languageWrapper":"Languages_languageWrapper__1X4ed","iconFlag":"Languages_iconFlag__9W3AB","wrapperDrawer":"Languages_wrapperDrawer__jRrn4"};